module.exports = {"blog":"https://blog.trello.com","twitter":"https://www.twitter.com/trello","facebook":"https://www.facebook.com/TrelloApp","google":"https://plus.google.com/103127084407107005900/posts"}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/data/locales/social/en.json
// module id = HRh6
// module chunks = 2 3 4